module.exports = __webpack_public_path__ + "img/ESC_NRW.cdac19bd.svg";